import React from 'react';
import { FaXTwitter, FaInstagram, FaGithub, FaDiscord } from 'react-icons/fa6';
import './Footer.scss';

interface SocialLink {
  name: string;
  url: string;
  icon: React.ReactNode;
  hoverColor: string;
  disabled?: boolean;
}

const socialLinks: SocialLink[] = [
  {
    name: 'X (Twitter)',
    url: 'https://x.com/klyxspace',
    icon: <FaXTwitter />,
    hoverColor: '#1DA1F2',
  },
  {
    name: 'Instagram',
    url: 'https://instagram.com/klyx.space',
    icon: <FaInstagram />,
    hoverColor: '#E4405F',
  },
  {
    name: 'GitHub',
    url: 'https://github.com/klyxspace',
    icon: <FaGithub />,
    hoverColor: '#333',
    disabled: true,
  },
  {
    name: 'Discord',
    url: 'https://discord.gg/klyx',
    icon: <FaDiscord />,
    hoverColor: '#5865F2',
    disabled: true,
  },
];

/**
 * Footer component displayed on every page
 * Features copyright text on left and social media icons on right
 */
export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-copyright">
          © {currentYear} Klyx. All rights reserved.
        </div>

        <div className="footer-social">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label={social.name}
              style={{ '--hover-color': social.hoverColor, 'display': social.disabled ? 'none' : '' } as React.CSSProperties}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
